import { Form, Input, Select, Switch } from "antd";
import React, { useState } from "react";
import { useCustomer } from "./store";

function ZeroValueOrder({
  category,
  setCategory,
  setCanSubmit,
  isZeroValueOrder,
  setZeroValueOrder,
  setIsZeroValueOrder,
  setSelectedDiscount,
  setIsCustomDiscount,
}) {
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const { customerData } = useCustomer();
  const withoutOrderId = [
    "sample",
    "medicalEscalation",
    "transplant",
    "influenceCampaign",
  ];

  const handleSubmitComment = (event) => {
    const commentEntered = event.target.value;
    setZeroValueOrder((prevData) => {
      return {
        ...prevData,
        zero_value_order_comment: commentEntered ? commentEntered : "",
        reason: commentEntered ? commentEntered : "",
      };
    });
    if (commentEntered.length) {
      setCanSubmit(true);
    } else {
      setCanSubmit(false);
    }
  };

  const handleOrderSelect = (value) => {
    setSelectedOrderId(value);

    const selectedOrder = customerData.orders.find(
      (order) => order.order_display_id === value
    );
    if (selectedOrder) {
      setZeroValueOrder((prevData) => {
        return { ...prevData, previous_order_id: selectedOrder.id };
      });
    } else {
      setZeroValueOrder((prevData) => {
        return { ...prevData, previous_order_id: "" };
      });
    }
  };

  const extractNumericPart = (order_display_id) => {
    const numericPart = order_display_id.replace(/[^\d]/g, "");
    return parseInt(numericPart, 10);
  };

  return (
    <div className="border rounded p-2 m-1">
      <div className="d-flex align-items-center ">
        <h3>Is Zero value Order</h3>
        <Switch
          className="mx-2"
          onChange={(toggle) => {
            setZeroValueOrder((prevData) => {
              return { ...prevData, is_zero_value_order: toggle };
            });
            setCanSubmit(!toggle);
            setIsZeroValueOrder(toggle);
            setIsCustomDiscount(toggle);
            if (!toggle) {
              console.log("I am coming under toggle");
              setSelectedDiscount(null);
              setCategory("");
              setSelectedOrderId(null);
              setZeroValueOrder((prevData) => {
                return { ...prevData, category: "" };
              });
            } else {
              console.log("I am inside set selected discounr");
              setSelectedDiscount({
                code: "custom_discount",
                amount: 100,
                type: "percentage",
                label: `Zero Value Order`,
              });
            }
          }}
        />
      </div>
      <div>
        {isZeroValueOrder && (
          <Form.Item label="Category" name="category">
            <Select
              placeholder="Select the category"
              onChange={(selectedCategory) => {
                setCategory(selectedCategory);
                setZeroValueOrder((prevData) => {
                  return { ...prevData, category: selectedCategory };
                });
                if (
                  withoutOrderId.includes(selectedCategory)
                ) {
                  setCanSubmit(false);
                }
              }}
              value={category}
            >
              <Select.Option value="onCxBehalf">
                On Customers Behalf
              </Select.Option>
              <Select.Option value="lost">Lost</Select.Option>
              <Select.Option value="replacement">Replacement</Select.Option>
              <Select.Option value="damaged">Damaged</Select.Option>
              <Select.Option value="sample">Sample Order</Select.Option>
              <Select.Option value="influenceCampaign">
                Influencer Campaign
              </Select.Option>
              <Select.Option value="medicalEscalation">
                Medical Escalation
              </Select.Option>
              <Select.Option value="transplant">Transplant</Select.Option>
            </Select>
          </Form.Item>
        )}
        {isZeroValueOrder && category && !withoutOrderId.includes(category) && (
          <div className="d-flex justify-content-between">
            <Form.Item label="Previous Order ID" name="orderId">
              <Select
                style={{ width: 200 }}
                value={selectedOrderId}
                placeholder="Select the order id"
                onChange={handleOrderSelect}
              >
                {customerData.orders
                  .slice()
                  .sort(
                    (orderA, orderB) =>
                      extractNumericPart(orderB.order_display_id) -
                      extractNumericPart(orderA.order_display_id)
                  )
                  .map((order) => (
                    <Select.Option
                      key={order.order_display_id}
                      value={order.order_display_id}
                    >
                      {order.order_display_id}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {selectedOrderId && (
              <Form.Item label="Comment" name="comment">
                <Input
                  placeholder="Add comment"
                  style={{ width: 200 }}
                  onChange={handleSubmitComment}
                />
              </Form.Item>
            )}
          </div>
        )}
        {isZeroValueOrder && withoutOrderId.includes(category) && (
          <Form.Item label="Comment" name="comment">
            <Input
              placeholder="Add comment"
              onChange={(event) => {
                const commentEntered = event.target.value;
                setCanSubmit(commentEntered.length);
                setZeroValueOrder((prevData) => {
                  return {
                    ...prevData,
                    zero_value_order_comment: commentEntered
                      ? commentEntered
                      : "",
                    reason: commentEntered ? commentEntered : "",
                  };
                });
              }}
            />
          </Form.Item>
        )}
      </div>
    </div>
  );
}

export default ZeroValueOrder;
